Object.defineProperty(exports, '__esModule', { value: true });

var Component_responsive = require('./Component.responsive.js');



exports.Tooltip = Component_responsive.TooltipResponsive;
